import React from "react";
import {
  withRouter,
} from "react-router-dom";

import FormX from "app/components/formx";
import GlobalCrud from "app/crud/global.crud.js";
import MiniList from "app/components/mini-list";
import BaseDropzone from "app/components/baseDropzone";

class Contacts extends BaseDropzone {

  constructor(props) {
    super();
    
    const { id } = props.match.params;
    this.id = id;
    this.path_prefix = (this.id ? "/"+this.id+"/" : '');

    this.crudUrl = new GlobalCrud(props.path);
  }

  form(values){

    let files = values && values['files_data'] ? values['files_data'] : [];

    return <FormX {...this.props} 
      fields={[
        [
          [
            {
              name : 'id',
              type : 'hidden',
              value : values && values['id'] ? values['id'] : '',
            },
            { 
              name : 'name', 
              type : 'text', 
              required : true,
              size : 6,
              value : values && values['name'] ? values['name'] : ''
            },
            { 
              name : 'relationship', 
              type : 'text', 
              required : true,
              size : 6,
              value : values && values['relationship'] ? values['relationship'] : ''
            },
            { 
              name : 'home', 
              label : 'Home #',
              type : 'inputmask',
              mask : '999-999-9999', 
              required : true,
              size : 4,
              value : values && values['home'] ? values['home'] : ''
            },
            { 
              name : 'work', 
              label : 'Work #',
              type : 'inputmask',
              mask : '999-999-9999', 
              required : true,
              size : 4,
              value : values && values['work'] ? values['work'] : ''
            },
            { 
              name : 'mobile', 
              label : 'Mobile #',
              type : 'inputmask',
              mask : '999-999-9999', 
              size : 4,
              value : values && values['mobile'] ? values['mobile'] : ''
            },
            { 
              name : 'files[]', 
              label : 'Attachments',
              type : 'dropzone',
              size : 12,
              value : files,
              showPreviews : true,
              handleDropzoneChange : this.handleDropzoneChange,
            },
          ]
        ]
      ]}
    />
  }

  render(){ 
    const { page_title, access } = this.props;
    const { files } = this.state;
    
    return (
      <>
      <div className="row">
        <div className="col-xl-12">
          <MiniList
          title={ page_title}
          apiPath={this.path_prefix+"contacts"}
          crudUrl={this.crudUrl}
          header={['Name', 'Relationship', 'Home', 'Work', 'Mobile']}
          body={['name', 'relationship', 'home', 'work', 'mobile']}
          form={this.form.bind(this)}
          uploads={files}
          {...access}
          />
        </div>
      </div>
      </>
    )
  }
}

export default withRouter(Contacts);